const SORT_CHAR = 's' // This value must not change! This is a workaround for get all records with sort functionality.

export default SORT_CHAR
